import Root from "./SegmentedControl.svelte";
import SegmentedControlOption from "./SegmentedControlOption.svelte";
/**
 * A radio group with the appearance of a segmented toggle.
 * Used for selecting between 2+ options.
 *
 * @example
 * ```
 * <SegmentedControl>
 *    <SegmentedControl.Option value="system" bind:group={$theme} label="system theme" hideLabel>
 *      <Icon aria-hidden="true" name="system" />
 *    </SegmentedControl.Option>
 *    <SegmentedControl.Option value="light" bind:group={$theme} label="light theme" hideLabel>
 *      <Icon aria-hidden="true" name="light" />
 *    </SegmentedControl.Option>
 *    <SegmentedControl.Option value="dark" bind:group={$theme} label="dark theme" hideLabel>
 *      <Icon aria-hidden="true" name="dark" />
 *   </SegmentedControl.Option>
 * </SegmentedControl>
 * ```
 */
export const SegmentedControl = Object.assign(Root, {
    Option: SegmentedControlOption,
});
